const input = {
    username: 'Nombre de usuario',
    password: 'Contraseña',
    email: 'Correo electrónico',
    phone_number: 'Número de teléfono',
    confirm_password: 'Confirmar contraseña',
    search_region_code: 'Código de región de búsqueda',
    backup_code: 'Código de respaldo',
    code: 'Código',
    label_with_optional: '{{label}} (Opcional)',
    email_address: 'Correo electrónico',
    email_placeholder: 'Introduce tu correo electrónico',
    enter_email: 'Introduce el correo electrónico',
};
export default Object.freeze(input);
